/**
 * Generates a URL-friendly ID from text (same logic as ContentfulDocument)
 * @param {string} title - The text to convert to ID
 * @returns {string} URL-friendly ID
 */
const getAnchorFromTitle = (title = '') => {
  const rxNonAlphanumeric = /[^a-z]+/g
  return title.trim().toLowerCase().replace(rxNonAlphanumeric, '-')
}

/**
 * Extracts plain text from a Contentful rich text node
 * @param {Object} node - The rich text node
 * @returns {string} Plain text content
 */
const extractTextFromNode = node => {
  if (!node.content) return ''

  return node.content
    .map(child => {
      if (child.nodeType === 'text') {
        return child.value
      }
      if (child.content) {
        return extractTextFromNode(child)
      }
      return ''
    })
    .join('')
}

/**
 * Extracts headings from Contentful rich text content to generate table of contents
 * @param {Object} contentfulData - The Contentful rich text data
 * @returns {Array} Array of heading objects with id, title, and level
 */
export const extractHeadings = contentfulData => {
  if (!contentfulData?.json?.content) {
    return []
  }

  const headings = []

  const traverseContent = content => {
    content.forEach(node => {
      // Check if the node is a heading (h1, h2, h3, etc.)
      if (node.nodeType === 'heading-1' || node.nodeType === 'heading-2' || node.nodeType === 'heading-3') {
        const text = extractTextFromNode(node)
        if (text) {
          const id = getAnchorFromTitle(text) // Use same ID generation as ContentfulDocument
          headings.push({
            id,
            title: text,
            level: parseInt(node.nodeType.split('-')[1]),
            menuTitle: text.split(':')[0], // Take only the part before colon for menu
          })
        }
      }

      // Recursively traverse child nodes
      if (node.content) {
        traverseContent(node.content)
      }
    })
  }

  traverseContent(contentfulData.json.content)
  return headings
}
